const ParameterConstants = {
    URL_EXTENSION: "/Tapu",

    REVENUE_TYPE_PARAMETER_TYPE: "1",

    VAT_STATUS_PARAMETER_TYPE: "2",

    VAT_RATE_PARAMETER_TYPE: "3",

    DELAY_STATUS_PARAMETER_TYPE: "4",

    DELAY_TYPE_PARAMETER_TYPE: "5",

    PARAMETER_TYPE_REGION_CODE: "6",

    PARAMETER_TYPE_USAGE_UNIT: "7",

    PARAMETER_TYPE_DEPOSIT_TYPE: "8",

    PARAMETER_TYPE_SUBSCRIBER_TYPE: "10",

    PARAMETER_TYPE_METER_TYPE: "12",

    PARAMETER_TYPE_METER_STATUS_TYPE: "13",

    PARAMETER_TYPE_APPLICATION_KIND: "14",

    PARAMETER_TYPE_SUBSCRIBER_KIND: "16",

    PARAMETER_TYPE_OCCUPATION: "17",

    PARAMETER_TYPE_SUBSCRIBER_GROUP: "18",

    PARAMETER_TYPE_TAX_OFFICES: "19",

    PARAMETER_TYPE_ENTERPRISE_TYPE: "20",

    PARAMETER_TYPE_APPROVAL_PRIORITY: "21",

    PARAMETER_TYPE_CONSTRUCTION_UNITS: "22",

    PARAMETER_TYPE_METER_KIND: "23",

    PARAMETER_TYPE_METER_WET_DRY_STATUS: "24",

    PARAMETER_TYPE_METER_INSPECTION_TYPE: "25",

    PARAMETER_TYPE_METER_MEASUREMENT_TYPE: "26",

    PARAMETER_TYPE_METER_BRAND: "27",

    PARAMETER_TYPE_METER_MOUNTING_STATUS: "28",

    PARAMETER_TYPE_PAYDESK_COLLECTION_TYPE: "29",

    PARAMETER_TYPE_CANCELLATION_REASON: "30",

    PARAMETER_TYPE_OPERATION_TYPE: "31",

    PARAMETER_TYPE_OPERATION_REASON: "32",

    PARAMETER_TYPE_DEBIT_NOTE_TYPE: "33",

    PARAMETER_TYPE_COLLECTION_PARAMETERS: "34",

    PARAMETER_RECEIPT_COUNT: "2",

    UNIT: "22",

    RETAIL_SUBSCIBER: "G",

    FOREIGNER_RETAIL_SUBSCIBER: "Y",

    CORPORATE_SUBSCIBER: "T",

    PUBLIC_SUBSCIBER: "K",

    OTHER_SUBSCIBER: "D",

    APPLICATION_TYPE_NEW_SUBSCRIPTION: "1",

    APPLICATION_TYPE_SUBCRIPTION_ASSIGNMENT: "2",

    APPLICATION_TYPE_ADDRESS_AND_SUBSCRIBER_INFORMATION_UPDATE: "3",

    APPLICATION_TYPE_DEPOSIT_RETURN: "4",

    APPLICATION_TYPE_TARIFF_REDUCTION: "5",

    APPLICATION_TYPE_SUBSCRIPTION_CANCELLATION: "6",

    APPLICATION_TYPE_METER_CHANGE: "7",

    APPLICATION_TYPE_TARIFF_CHANGE: "20",

    APPLICATION_VIA_ACTING: "3",

    REVENUE_TYPE_USAGE: "1",

    REVENUE_TYPE_FACILITY: "2",

    REVENUE_TYPE_DEPOSIT: "3",

    COLLECTION_TYPE_CASH: "1",

    COLLECTION_TYPE_POSTAL_CHEQUE: "2",

    COLLECTION_TYPE_DEBIT_NOTE: "3",

    COLLECTION_TYPE_CREDIT_CARD: "4",

    COLLECTION_TYPE_DEPOSIT_DEBIT_NOTE: "5",

    OPERATION_TYPE_METER_RIPPING: "1",

    OPERATION_TYPE_METER_MOUNTING: "2",

    OPERATION_TYPE_METER_REPLACEMENT: "3",

    APPLICATION_TYPE_WATER_LINE_ACTIVATION: "10",

    APPLICATION_TYPE_INVOICE_GENERATION: "15",

    APPLICATION_TYPE_INVOICE_INVOICE_AND_METER_APPEAL: "14",

    PARAMETER_TYPE_LATE_DEBT_QUERY_TYPE: "35",

    PARAMETER_TYPE_LATE_DEBT_OPERATION_TYPE: "36",

    PARAMETER_TYPE_WATER_LINE_STATUS: "37",

    PARAMETER_TYPE_WATER_LINE_CUTTING_METHOD: "38",

    LATE_DEBT_QUERY_TYPE_AMOUNT_DUE: "1",

    LATE_DEBT_QUERY_TYPE_BILLS_DUE: "2",

    LATE_DEBT_OPERATION_TYPE_SEND_NOTICE: "1",

    LATE_DEBT_OPERATION_TYPE_CUT_WATER: "2",

    WATER_LINE_STATUS_ACTIVE: "1",

    WATER_LINE_STATUS_CUT_REQUEST_SENT: "2",

    WATER_LINE_STATUS_CUT: "3",

    WATER_LINE_STATUS_CUT_REQUEST_REJECTED: "4",

    APPLICATION_TYPE_ILLEGAL_WATER_USAGE_NOTIFICATION: "21",

    UNKNOWN_WATER_USER: "B",
    //new
    PARAMETER_TYPE_ILLEGAL_WATER_USAGE_METHOD: "39",

    PARAMETER_TYPE_ILLEGAL_WATER_USAGE_SUBSCRIPTION_STATUS: "40",

    PARAMETER_TYPE_ILLEGAL_WATER_USAGE_METER_STATUS: "41",

    ILLEGAL_WATER_USAGE_SUBSCRIPTION_STATUS_IS_A_SUBSCRIBER: "1",

    ILLEGAL_WATER_USAGE_SUBSCRIPTION_STATUS_IS_NOT_A_SUBSCRIBER: "0",

    ILLEGAL_WATER_USAGE_METER_STATUS_METER_WORKING: "1",

    ILLEGAL_WATER_USAGE_METER_STATUS_METER_NOT_WORKING: "2",

    ILLEGAL_WATER_USAGE_METER_STATUS_NO_METER: "3",

    PARAMETER_TYPE_INSTALLMENT_METHODS: "42",

    APPLICATION_TYPE_STOLEN_METER_CHANGE: "13",

    APPLICATION_TYPE_APPARATUS_BREAKING: "12",

    APPLICATION_TYPE_MAKING_INSTALLMENT: "22",

    INSTALLMENT_METHOD_ALL_DEBTS: "1",

    INSTALLMENT_METHOD_LATE_DEBTS: "2",

    PARAMETER_TYPE_METER_CHANGE_OPERATION_STATUS: "43",

    PARAMETER_TYPE_OPERATION_LOG_STATUS: "44",

    PARAMETER_TYPE_APPROVAL_LOG_STATUS: "45",

    PARAMETER_TYPE_SUBSCRIPTION_STATUS: "46",

    ALL_APPLICATION_METHODS: "*",

    ALL_SUBSCRIBER_TYPES: "*",

    PARAMETER_TYPE_SUBSCRIPTION_PARAMETERS: "47",

    SUBSCRIPTION_PARAMETERS_NDIS_STATUS: "1",

    PARAMETER_TYPE_DEPOT: "48",

    PARAMETER_TYPE_PUMP: "49",

    PARAMETER_TYPE_NETWORK_TYPE: "50",

    PARAMETER_TYPE_PIPE_TYPE: "51",

    PARAMETER_TYPE_CHANNEL_TYPE: "52",

    APPLICATION_TYPE_SUBSCRIPTION_DEACTIVATION: "8",

    PARAMETER_TYPE_DEACTIVATION_REASONS: "53",

    INSTALLED_PDF_PRINTER_NAME: "Foxit Reader PDF Printer",

    APPLICATION_TYPE_ILLEGAL_WATER_USAGE_APPEAL: "11",

    PARAMETER_TYPE_ENFORCEMENT_OFFICES: "54",

    PARAMETER_TYPE_TRACE_METHOD: "55",

    PARAMETER_TYPE_DECISION_TYPE: "56",

    PARAMETER_TYPE_ENFORCEMENT_PARAMETERS: "57",

    PARAMETER_CODE_COLLECTION_EXPENSE_RATIO_KEY: "10",

    PARAMETER_TYPE_FILE_FIELD_INFORMATION: "58",

    PARAMETER_TYPE_FILE_DEBT_INFORMATION_FIELDS: "59",

    PARAMETER_TYPE_FILE_HEADER_FOOTER_INFORMATION_FIELDS: "60",

    PARAMETER_TYPE_FILE_DATA_TYPE: "61",

    PARAMETER_TYPE_CHARACTER_FILLING_DIRECTION: "62",

    PARAMETER_TYPE_FILE_NAME_FIELDS: "63",

    PARAMETER_TYPE_FILE_STATUS: "64",

    PARAMETER_TYPE_FILE_ENCODINGS: "65",

    PARAMETER_TYPE_INCOMING_FILE_STATUS: "66",

    OUTGOING_FILE: "O",

    INCOMING_FILE: "I",

    HEADER_INFORMATION: "H",

    FOOTER_INFORMATION: "F",

    DEBT_INFORMATION: "B",

    FILE_NAME_INFORMATION: "N",

    CHARACTER_FILLING_DIRECTION_RIGHT: "R",

    CHARACTER_FILLING_DIRECTION_LEFT: "L",

    PARAMETER_TYPE_ACTIVITY_TYPES: "84",

    PARAMETER_INSTALLMENT_EXPIRATION_TYPE: "85",

    RESTRUCTURING_ACTIVE_OR_CANCELLED_STATUS: "86",

    PARAMETER_INSTALLMENT_INTERVAL_SPECIFIER_DAY: "0",

    PARAMETER_INSTALLMENT_INTERVAL_SPECIFIER_MONTH: "1",

    PARAMETER_TYPE_COMPLAINT_AND_REQUEST_STATUS: "90",

    PARAMETER_TYPE_NOTIFICATION_CHANNEL: "91",

    PARAMETER_TYPE_NOTIFICATION_ACTION: "92",

    NOTIFICATION_ACTION_NEW_NOTIFICATION: "1",

    APPLICATION_TYPE_HOME_OWNER: "1",

    BLOCK_OF_BUILDINGS_PARAMETER_TYPE: "97",

    PARAMETER_TYPE_IRRIGATION_TYPE: "98",

    SOWING_TYPE_CODE: "94",

    EXEMPTION_OF_AREA_PARAMETER_TYPE: "99",

    NOTARY_NAME_PARAMETER_TYPE: "100",

    REVENUE_TYPE_FOR_GENERAL_ACCRUMENT: "3",

    PARAMETER_TYPE_OPERATION_TYPE_OF_DEACTIVATE: "101",

    PARAMETER_TYPE_OPERATION_TYPE_CANCEL: "1",

    PARAMETER_TYPE_OPERATION_TYPE_SALE: "2",

    PARAMETER_TYPE_MEMBER_TYPE: "102",

    PARAMETER_TYPE_LAND_STATUS: "103",

    PARAMETER_TYPE_APPLICATION_TYPE_FOR_ACCRUMENT_APPEAL: "104",

    PARAMETER_TYPE_APPLICATION_METHOD_FOR_ACCRUMENT_APPEAL: "105",

    PARAMETER_TYPE_STORAGEHOUSE: "93",

    PARAMETER_TYPE_PERSONNEL_QUALIFICATION: "142",

    PARAMETER_TYPE_CORPORATE_CLASSIFICATION_CONTROL: "143",

    PARAMETER_CODE_CORPORATE_CLASSIFICATION_DEFINITION_LEVEL_MAX_VALUE: "1",

    PARAMETER_CODE_CORPORATE_CLASSIFICATION_UPDATE_LEVEL_MIN_VALUE: "2",

    PARAMETER_CODE_CORPORATE_CLASSIFICATION_CONTROL_IS_USED: "3",

    PARAMETER_TYPE_EXPENSE_ECONOMIC_CLASSIFICATION_CONTROL: "144",

    PARAMETER_CODE_EXPENSE_ECONOMIC_CLASSIFICATION_DEFINITION_LEVEL_MIN_VALUE: "1",

    PARAMETER_CODE_EXPENSE_ECONOMIC_CLASSIFICATION_DEFINITION_LEVEL_MAX_VALUE: "2",

    PARAMETER_CODE_EXPENSE_ECONOMIC_CLASSIFICATION_UPDATE_LEVEL_MIN_VALUE: "3",

    PARAMETER_CODE_EXPENSE_ECONOMIC_CLASSIFICATION_CONTROL_IS_USED: "4",

    PARAMETER_TYPE_FINANCING_ECONOMIC_CLASSIFICATION_CONTROL: "145",

    PARAMETER_CODE_FINANCING_ECONOMIC_CLASSIFICATION_DEFINITION_LEVEL_MAX_VALUE: "1",

    PARAMETER_CODE_FINANCING_ECONOMIC_CLASSIFICATION_UPDATE_LEVEL_VALUE: "2",

    PARAMETER_CODE_FINANCING_ECONOMIC_CLASSIFICATION_CONTROL_IS_USED: "3",

    PARAMETER_TYPE_FUNCTIONAL_CLASSIFICATION_CONTROL: "146",

    PARAMETER_CODE_FUNCTIONAL_CLASSIFICATION_DEFINITION_LEVEL_MAX_VALUE: "1",

    PARAMETER_CODE_FUNCTIONAL_CLASSIFICATION_UPDATE_LEVEL_VALUE: "2",

    PARAMETER_CODE_FUNCTIONAL_CLASSIFICATION_CONTROL_IS_USED: "3",

    PARAMETER_TYPE_MOVABLE_CALCULATION_PLAN_CONTROL: "147",

    PARAMETER_CODE_MOVABLE_CALCULATION_PLAN_DEFINITION_LEVEL_MAX_VALUE: "1",

    PARAMETER_CODE_MOVABLE_CALCULATION_PLAN_UPDATE_LEVEL_VALUE: "2",

    PARAMETER_CODE_MOVABLE_CALCULATION_PLAN_CONTROL_IS_USED: "3",

    PARAMETER_TYPE_REVENUE_ECONOMIC_CLASSIFICATION_CONTROL: "148",

    PARAMETER_CODE_REVENUE_ECONOMIC_CLASSIFICATION_DEFINITION_LEVEL_MIN_VALUE: "1",

    PARAMETER_CODE_REVENUE_ECONOMIC_CLASSIFICATION_DEFINITION_LEVEL_MAX_VALUE: "2",

    PARAMETER_CODE_REVENUE_ECONOMIC_CLASSIFICATION_UPDATE_LEVEL_VALUE: "3",

    PARAMETER_CODE_REVENUE_ECONOMIC_CLASSIFICATION_CONTROL_IS_USED: "4",

    PARAMETER_TYPE_MOVABLE_CALCULATION_PLAN_CONTROL_FOR_CALCULATION_CODE: "149",

    PARAMETER_CODE_MOVABLE_CALCULATION_PLAN_CODE_FOR_FIRST_LEVEL: "1",

    PARAMETER_CODE_MOVABLE_CALCULATION_PLAN_CODE_FOR_OTHER_LEVEL: "2",

    PARAMETER_TYPE_MATERIAL_TYPE_CODE: "150",

    PARAMETER_TYPE_REGISTRY_TYPES: "151",

    REGISTRY_TYPE_RETAIL_REGISTRY: "G",

    REGISTRY_TYPE_FOREIGNER_RETAIL_REGISTRY: "Y",

    REGISTRY_TYPE_CORPORATE_REGISTRY: "T",

    REGISTRY_TYPE_PUBLIC_REGISTRY: "K",

    REGISTRY_TYPE_OTHER_REGISTRY: "D",

    PARAMETER_CODE_VAT_INCLUSIVE: "1",

    PARAMETER_CODE_VAT_NOT_AVAILABLE: "2",

    PARAMETER_CODE_VAT_EXCLUSIVE: "3",

    PARAMETER_TYPE_DEREGISTRATION_REASON: "168",

    PARAMETER_TYPE_DEREGISTRATION_TYPE: "169",

    PARAMETER_TYPE_DISABILITY_TYPES: "194",

    PARAMETER_TYPE_VACATION_FORM_CODE: "193",

    PARAMETER_TYPE_BASE_TYPES: "195",

    PARAMETER_TYPE_MARITAL_STATUS: "71",

    PARAMETER_TYPE_GENDER: "74",

    PARAMETER_TYPE_TAX_GROUP: "202",

    PARAMETER_TYPE_SPOUSE_FAMILY_RELIEF: "203",
    SERVICE_CHANGE_REASON_MANDATORY_FIELD: "218",
    SERVICE_CHANGE_REASON_REASON_TYPE: "219",

    PARAMETER_TYPE_BALANCE_TYPE: "207",
    PARAMETER_TYPE_USAGE_OF_BUDGET: "237",

    PARAMETER_TYPE_RECEIPT_TYPE: "211",

    PARAMETER_TYPE_DUTY_ALLOWANCE_DAILY_WAGE_INTERVAL_TYPES: "223",

    DUTY_ALLOWANCE_DAILY_WAGE_INTERVAL_TYPE_PAYMENT_ADDITIONAL_INDICATOR: "1",

    DUTY_ALLOWANCE_DAILY_WAGE_INTERVAL_TYPE_PAYMENT_DEGREE: "2",

    PARAMETER_TYPE_CURRENCY_CODES: "224",

    //Muhasebe hesap plan tanım - hesap tipleri 

    MAIN_ACCOUNTING_ACCOUNT_PLAN_TYPE: "0",

    ACCOUNTING_ACCOUNT_GROUP_PLAN_TYPE: "1",

    ACCOUNTING_ACCOUNT_PLAN_TYPE: "2",

    FIRST_HELPER_ACCOUNTING_ACCOUNT_PLAN_TYPE: "3",

    SECOND_HELPER_ACCOUNTING_ACCOUNT_PLAN_TYPE: "4",

    THIRD_HELPER_ACCOUNTING_ACCOUNT_PLAN_TYPE: "5",

    FOURTH_HELPER_ACCOUNTING_ACCOUNT_PLAN_TYPE: "6",

    FIFTH_HELPER_ACCOUNTING_ACCOUNT_PLAN_TYPE: "7",

    VALUE_FOR_TO_ADD_CURRENT_YEAR: 10,

    ACTIVE_ACCOUNTING_ACCOUNT_PLAN_STATUS: "1",

    PASSIVE_ACCOUNTING_ACCOUNT_STATUS: "0",

    DELETED_ACCOUNTING_ACCOUNT_STATUS_BY_USER: "2",

    ACCOUNTING_ACCOUNT_PLAN_CODE_FOR_FIRST_LEVEL: "1",

    TOP_PARENT_OID_BY_RELATED_YEAR: 0,

    TOP_PARENT_ACCOUNTING_TYPE_BY_RELATED_YEAR: "-1",

    INVALID_ACCOUNTING_ACCOUNT_TYPE: "A",

    TOP_PARENT_ACCOUNTING_ACCOUNT_CODE: "1",

    GET_ALL_VALUES_OF_ACCOUNTING_ACCOUNT_PLANS_FOR_RELATED_YEAR: -1,

    GET_ALL_ACCOUNTING_ACCOUNT_PLAN_LEAF: "1",

    GET_PROCESS_BY_FIRST_VAT_OPERATION: "215",

    PARAMETER_TYPE_ACCOUNT_TYPE: "220",

    GET_ALL_VALUES_OF_ACCOUNTING_ACCOUNT_PLANS_WHOSE_PARENT_CODE_PATH_STARTING_102: "102",

    PARAMETER_TYPE_ACCOUNTING_PAYMENT_TYPE: "225",

    GET_ALL_VALUES_OF_ACCOUNTING_ACCOUNT_PLANS_WHOSE_PARENT_CODE_PATH_STARTING_103: "103",

    MINIMUM_VALUE_OF_ACCOUNTING_ACCOUNT_PLAN_CODE_LENGTH: 2,

    //Kredi Türü

    PARAMETER_TYPE_CREDIT_TYPE: "230",

    //döviz kurları
    EXCHANGE_RATE_MANUALLY_ENTERED: "1",

    EXCHANGE_RATE_QUERIED_FROM_TCMB: "2",

    PARAMETER_TYPE_BANK_ACCOUNT_USAGE_PURPOSE: "205",

    VAT_EXPENSE_ACCOUNTS: "1", //kdv gider hesapları

    VAT_INCOME_ACCOUNTS: "2", // kdv gelir hesapları

    BUDGET_DEPOSIT_ACCOUNTS: "3", //bütçe emanet hesapları

    DEPOSIT_ACCOUNT: "4", // emanet hesapları

    ADVANCE_ACCOUNTS: "5", // avans hesapları

    CREDIT_ACCOUNTS: "6", // kredi hesapları

    PROMISE_ACCOUNTS: "7", // taahhüt hesapları

    PARAMETER_CODE_BANK_ACCOUNT_USAGE_PURPOSE_DEPOSIT: "1",
    PARAMETER_CODE_BANK_ACCOUNT_USAGE_PURPOSE_PRIVATE_PENSION_SYSTEM: "2",
    PARAMETER_TYPE_LANGUAGE_TYPES: "231",
    PARAMETER_TYPE_LANGUAGE_LEVELS: "232",
    PARAMETER_TYPE_LANGUAGE_UTILIZATION_STATUS: "233",
    PARAMETER_TYPE_EMPLOYMENT_STATUS: "235",
    PARAMETER_TYPE_CIVIL_SERVICE_STATUS: "236",

    PARAMETER_TYPE_LICENSE_STATUS: "165",

    PARAMETER_TYPE_CREW_OPERATIONS_FOR_CREW_OPERATION_SERIAL_INFO: "141",
    PARAMETER_TYPE_ENFORCEMENT_TYPES: "239",
    PARAMETER_TYPE_ENFORCEMENT_DEDUCTION_RATIOS: "240",
    PARAMETER_TYPE_ENFORCEMENT_AMOUNT_CHANGE_TYPES: "241",
    PARAMETER_CODE_ENFORCEMENT_DEDUCTION_RATIO_FIXED: "1",
    PARAMETER_TYPE_STAMP_TAX_TYPE: "238",

    PARAMETER_TYPE_ACCOUNT_USAGE_PURPOSE_TYPE: "242",

    GET_ALL_ACCOUNT_USAGE_PURPOSE_VALUES: null,

    PARAMETER_CODE_USAGE_OF_BUDGET_REVENUE_BUDGET: "1",
    PARAMETER_CODE_USAGE_OF_BUDGET_EXPENSE_BUDGET: "2",
    PARAMETER_CODE_USAGE_OF_BUDGET_BUDGET_IS_NOT_USED: "3",

    //izin parametre 

    PARAMETER_CODE_DURATION_TYPE: "243",

    //teminat işlem tipleri
    PARAMETER_TYPE_LETTER_OPERATION_TYPES: "204",

    PARAMETER_TYPE_LEAVE_APPLICCATION_STATUS: "248",
    PARAMETER_TYPE_PERSONNEL_REPORT_KIND: "249",
    PARAMETER_TYPE_REPORT_STATUS: "250",
    PARAMETER_TYPE_TRANSACTION_TYPES: "251",

    PARAMETER_TYPE_RECEIPT_OPERATION_PURPOSE: "247",
    PARAMETER_CODE_RECEIPT_OPERATION_PURPOSE_NORMAL_OPERATION: "1",
    PARAMETER_CODE_RECEIPT_OPERATION_PURPOSE_END_OF_YEAR_OPERATION: "2",
    PARAMETER_CODE_RECEIPT_OPERATION_PURPOSE_NEW_YEAR_OPERATION: "3",

    PARAMETER_TYPE_APPLICATION_TYPE: "11",

    UNDETAILED_SUBSCRIBER: "U",

    UNKNOWN_SUBSCRIBER: "B",

    OPERATION_REASON_METER_PERIODIC_MAINTENANCE: "8",

    APPLICATION_TYPE_CONTRACT_CANCELATION: "9",

    PARAMETER_TYPE_INFRASTRUCTURE_KIND: "108",

    REVENUE_TYPE_FOR_INFRASTRUCTURE: "6",

    PARAMETER_CODE_DEFAULT_OCCUPATION_CODE: "6",

    PARAMETER_CODE_DEFAULT_TAX_OFFICE: "081262",

    APPLICATION_TYPE_BUILDING_EXPLORATION: "23",

    PARAMETER_TYPE_APPLICATION_ADDRESS_SOURCE: "100",

    PARAMETER_TYPE_APPLICATION_UPPER_TYPE: "107",

    PARAMETER_TYPE_APPLICATION_FEEDBACK: "109",

    APPLICATION_TYPE_CHANNEL_BRACKS_OUT: "24",

    APPLICATION_TYPE_CHANNEL_CONGESTION: "25",

    PARAMETER_TYPE_CODE_GENDER: "74",

    PARAMETER_TYPE_PARCENTAGE_AND_MIN_PARTICIPATION_AMOUNT_INFO_TO_CALCULATE_UPPER_AND_LOWER_PARTICIPATION_AMOUNT: "112",

    PARAMETER_TYPE_PARCENTAGE_TO_CALCULATE_CASH_PARTICIPATION_AMOUNT: "113",

    PARAMETER_TYPE_INSTALLMENT_INFO_TO_CALCULATE_PARTICIPATION_AMOUNT: "114",

    OPERATION_TYPE_CODE_TO_CREATING_ENFORCEMENT_REPORT: "116",

    PARAMETER_TYPE_ENFORCEMENT_STATUS: "117",

    APPLICATION_TYPE_COLLECTION_RETURN: "29",

    RECONSTRUCTION_FIELD_TYPE_PROJECT_LOCATION_INFO_CODE: 1,

    RECONSTRUCTION_FIELD_TYPE_BUILDING_OWNER_INFO_CODE: 2,

    RECONSTRUCTION_FIELD_TYPE_SUPERVISION_COMPANY_INFO_CODE: 3,

    RECONSTRUCTION_FIELD_TYPE_BUILDING_CONSTRUCTOR_INFO_CODE: 4,

    RECONSTRUCTION_FIELD_TYPE_ARCHIVE_INFO_CODE: 5,

    RECONSTRUCTION_FIELD_TYPE_ARCHIVE_DOCUMENT_INFO_CODE: 6,

    PARAMETER_TYPE_ARCHIVE_DOCUMENT_FORMAT_INFO: "123",

    PARAMETER_TYPE_DEGRE_OF_SECURITY: "118",

    PARAMETER_TYPE_LIQUIDATION_TYPE: "119",

    PARAMETER_TYPE_STATE_ARCHIVE_DURATION: "121",

    PARAMETER_TYPE_STANDART_FILE_PLAN_ROOT_VISIBLE: "122",

    STANDART_FILE_PLAN_ROOT_VISIBLE: "1",

    INDEFINITE: "*",

    PARAMETER_TYPE_PURPOSE_OF_USAGE: "125",

    PARAMETER_TYPE_PURPOSE_OF_LICENSE_ISSUANCE: "126",

    PARAMETER_TYPE_MAP_SCALE_TYPE: "127",

    PARAMETER_TYPE_BUILDING_MATERIAL_CLASS: "128",

    PARAMETER_TYPE_ARCHITECTURAL_SERVICE_CLASS: "129",

    PARAMETER_TYPE_CONSTRUCTION_TYPE: "130",

    PARAMETER_TYPE_SUBSCRIPTION_STATUS_FOR_ILLEGAL_WATER_USAGE: "131",

    PARAMETER_TYPE_ILLEGAL_WATER_USAGE_PARAMETER_NAME: "132",

    PARAMETER_TYPE_ILLEGAL_WATER_USAGE_DURATION_UNIT: "133",

    RECONSTRUCTION_ARCHIVE_OPERATION_GROUP_CODE: "013",

    RECONSTRUCTION_ARCHIVE_OBSERVATION_OPERATION_CODE: "001",

    PARAMETER_TYPE_BUILDING_STATUS: "139",

    WATERLINE_CUTTING_REASON_LATE_DEBT: "1",

    WATERLINE_CUTTING_REASON_CONTRACT_CANCELLATION: "2",

    APPLICATION_TYPE_SERVICE_ACCRUMENT: "33",

    CONSTRUCTION_TYPE_SERVICE_APPLICATION: 5,

    PARAMETER_TYPE_EXPENSE_TYPE: "154",

    PARAMETER_CODE_EXPENSE_TYPE_FIRST_OPERATION_INTEREST: "1", // İşlem Faizi-1

    PARAMETER_CODE_EXPENSE_TYPE_SECOND_OPERATION_INTEREST: "2", // İşlem Faizi-2

    PARAMETER_CODE_EXPENSE_TYPE_COMPENSATION: "3", // Tazminat Tutarı

    PARAMETER_CODE_EXPENSE_TYPE_PROTEST: "4", // Protesto Tutarı

    PARAMETER_CODE_EXPENSE_TYPE_NOTICE: "5",  // İhbar Tutarı

    PARAMETER_CODE_EXPENSE_TYPE_ACTING_FEE: "6", // Vekalet Ücreti

    PARAMETER_CODE_EXPENSE_TYPE_BAR_COUNCIL_EXPENSE: "7", //Baro Vekalet Pulu

    PARAMETER_CODE_EXPENSE_TYPE_RECORD_EXPENSE: "8",  // Dosya Gideri

    PARAMETER_CODE_EXPENSE_TYPE_ACTING_FEES: "9",  // Vekalet Harcı

    PARAMETER_CODE_EXPENSE_TYPE_APPLICATION_FEES: "10",  // İcra Başvuru Harcı

    PARAMETER_CODE_EXPENSE_TYPE_COLLECTION_FEES: "11",  // Tahsilat Harcı

    PARAMETER_CODE_EXPENSE_TYPE_CASH_FEES: "12",  // Peşin Harç

    PARAMETER_CODE_EXPENSE_TYPE_LAWSUIT_ACTING_FEE: "13",  // Dava Vekalet Ücreti

    PARAMETER_CODE_EXPENSE_TYPE_PUNISHMENT_ACTING_FEE: "14",  // İcra Ceza Vekalet Ücreti

    PARAMETER_CODE_WATERLINE_CUTTING_OPERATION_FOR_CREW: "1",

    PARAMETER_TYPE_OLD_METER_STATUS_WHEN_METER_RIPPING: "157",

    CONSTRUCTION_TYPE_METER_CHANGE: 5,

    PARAMETER_TYPE_EXCEEDING_STANDART_SMS_LENGTH: "156",
    PARAMETER_TYPE_MESSAGE_STATUS: "158",
    PARAMETER_TYPE_MESSAGE_SENDING_TIME_UNIT: "159",
    PARAMETER_TYPE_INVOICE_APPEAL_OPERATION_STATUS_CODES: "163",

    APPLICATION_TYPE_METER_CONFUSION_CORRECTION: "16",

    PARAMETER_TYPE_VEHICLE_KIND: "170",

    PARAMETER_TYPE_VEHICLE_TYPE: "171",

    PARAMETER_TYPE_VEHICLE_FUEL_TYPE: "172",

    PARAMETER_TYPE_CODE_EXEMPTION_TYPES: "177",

    PARAMETER_CODE_RATIO_BASED_EXEMPTION_TYPE: "1",

    PARAMETER_CODE_PROTOCOL_BASED_EXEMPTION_TYPE: "2",

    PARAMETER_TYPE_CONSUMPTION_CRITERIA: "179",

    PARAMETER_TYPE_WATER_LINE_NOTICE_SOURCE: "136",
    PARAMETER_TYPE_WATER_LINE_CUTTING_SOURCE: "187",
    PARAMETER_TYPE_WATER_LINE_ACTIVATION_SOURCE: "188",

    ANY_SUBSCRIPTION_STATUS: "-1",

    ANY_TARIFF_CODE: -1,

    ANY_METER_STATUS: "-1",

    PARAMETER_TYPE_ARCHITECTURAL_SERVICE_GROUP: "191",

    PARAMETER_TYPE_ACCRUMENT_STATUS: "197",

    APPLICATION_TYPE_APPLICATION_SERVICE_ACCRUMENT_APPEAL: "34",

    PARAMETER_TYPE_STAMP_DUTY_PARAMETERS: "209",

    PARAMETER_TYPE_REVENUE_USAGE_PURPOSE: "210",

    PARAMETER_CODE_REVENUE_USAGE_PURPOSE_NEW_SUBSCRIPTION_CONTRACT_ACCRUMENT: "1",

    PARAMETER_CODE_REVENUE_USAGE_PURPOSE_SUBSCRIPTION_ASSIGNMENT_CONTRACT_ACCRUMENT: "2",

    PARAMETER_TYPE_VEHICLE_TRACKING_TRANSFER_EXPENSE_PARAMETERS: "217",

    PARAMETER_CODE_DAILY_TRANSFER_EXPENSE: "1",

    PARAMETER_TYPE_ACCRUMENT_TYPES: "173",

    PARAMETER_TYPE_ACCRUMENT_ACTIVITY_TYPES: "174",

    PARAMETER_TYPE_GENERAL_ARCHIVE_ADDITIONAL_FIELDS_DATA_TYPES: "245",

    PARAMETER_CODE_DATA_TYPE_TEXT: "1",

    PARAMETER_CODE_DATA_TYPE_NUMBER: "2",

    PARAMETER_CODE_DATA_TYPE_DATE: "3",

    PARAMETER_CODE_DATA_TYPE_CHECKBOX: "4",

    DOCUMENT_FILENAME_LENGTH_LIMIT: 25,

    PARAMETER_TYPE_WORKER_SCORE_CARD_RULER_STATUS: "259",

    PARAMETER_TYPE_WORKER_OVERTIME_SCORE_CARD_RULER_STATUS: "262",

    PARAMETER_TYPE_SSI_TYPE_BASE: "265",

    PARAMETER_TYPE_WORKER_OR_CORPORATION_SPECIFIER_TYPE: "266",

    DISTANCE_UNIT_KILOMETER: 'K',

    DISTANCE_UNIT_NAUTICAL_MILES: 'N',

    DISTANCE_UNIT_MILES: 'M',

    DISTANCE_UNIT_METER: 'T',

    PARAMETER_TYPE_FILE_GENERATION_REQUEST_STATUS: "269",

    REVENUE_TYPE_TAX: "7",

    REVENUE_TYPE_TAX_GOOD: "9",

    PARAMETER_ESTATE_TYPE: "267",

    USAGE_TYPE_INNER_DOOR: "255",

    DETACHED_SECTION_INNER_DOOR: "270",

    FINANCING_TYPE_STATUS_ACTIVE: "1",

    FINANCING_TYPE_STATUS_PASSIVE: "0",

    FINANCING_TYPE_STATUS_DELETED_BY_USER: "2",

    EXPENSE_ECONOMIC_CLASSIFICATION_STATUS_ACTIVE: "1",

    EXPENSE_ECONOMIC_CLASSIFICATION_STATUS_PASSIVE: "0",

    EXPENSE_ECONOMIC_CLASSIFICATION_STATUS_DELETED_BY_USER: "2",

    CORPORATE_CLASSIFICATION_STATUS_ACTIVE: "1",

    CORPORATE_CLASSIFICATION_STATUS_PASSIVE: "0",

    CORPORATE_CLASSIFICATION_STATUS_DELETED_BY_USER: "2",

    FUNCTIONAL_CLASSIFICATION_STATUS_ACTIVE: "1",

    FUNCTIONAL_CLASSIFICATION_STATUS_PASSIVE: "0",

    FUNCTIONAL_CLASSIFICATION_STATUS_DELETED_BY_USER: "2",

    PRIVATE_PENSION_SYSTEM_CALCULATION_TYPES: "316",

    CONTRACTED_EMPLOYEE_WAGE_RULER_ONE_AMOUNT_TYPES: "323",

    SUSPENSION_SALARY_RATIOS: "354",

    PRORATA_SALARY_REASONS: "355",

    PRORATA_SALARY_TYPES: "356",

    PARAMETER_TYPE_SUSPENSION_SCORE_CARD_ACCRUMENT_STATUS_TYPES: "359",

    PARAMETER_TYPE_RECEIPT_REPORT_MARGINS: "364",

    PARAMETER_CODE_RECEIPT_REPORT_TOP_PAGE_LEFT_POINT: 0,

    PARAMETER_CODE_RECEIPT_REPORT_TOP_PAGE_TOP_POINT: 1,

    PARAMETER_CODE_RECEIPT_REPORT_SUB_PAGE_LEFT_POINT: 2,

    PARAMETER_CODE_RECEIPT_REPORT_SUB_PAGE_TOP_POINT: 3,

    FUNCTIONAL_CODE_USAGE_PURPOSES: "363",

    SOCIAL_SECURITY_INTITUTION_DATA_PREPARE_USAGE_PURPOSES: "365",

    PARAMETER_TYPE_COMMITTEE_RESOLUTION_RESULTS: "367",

    PARAMETER_TYPE_COUNCIL_RESOLUTION_RESULTS: "368",

    PARAMETER_TYPE_AGENDA_TOPIC_STATUS: "369",

    PARAMETER_TYPE_DEPARTMENT_TYPES: "373",

    REGISTRY_TYPE_UNDETAILED_REGISTRY: "U",

    PARAMETER_TYPE_MEASURING_POINTS: "374",

    APPLICATION_TYPE_WATERLINE_CUTTING_ON_PURPOSE: "38",

    APPLICATION_TYPE_SUBSCRIBER_NO_CHANGE: "44",

    PARAMETER_TYPE_CREW_TYPES: "375",

    CREW_TYPE_PARAMETER_FOR_WATER_SERVICE_APPLICATION: "1",

    CREW_TYPE_PARAMETER_FOR_METER_CHANGE: "2",

    CREW_TYPE_PARAMETER_FOR_METER_PERIODIC_MAINTENANCE: "3",

    CREW_TYPE_PARAMETER_FOR_METER_REPAIR: "4",

    CREW_TYPE_PARAMETER_FOR_CANAL: "5",

    CREW_TYPE_PARAMETER_FOR_WATERLINE: "6",

    CREW_TYPE_PARAMETER_FOR_ILLEGAL_WATER_USAGE: "7",

    CREW_TYPE_PARAMETER_FOR_LATE_DEBT_NOTICE: "8",

    CREW_TYPE_PARAMETER_FOR_CONTRACT_CANCELLATION: "9",

    CREW_TYPE_PARAMETER_FOR_SUBSCRIPTION_DEACTIVATION: "10",

    CREW_TYPE_PARAMETER_FOR_WATERLINE_CUTTING_ACTIVATION: "11",

    CREW_TYPE_PARAMETER_FOR_SEWERAGE_SERVICE_APPLICATION: "12",

    CREW_TYPE_PARAMETER_FOR_CANAL_EXPLORATION: "13",

    CREW_TYPE_PARAMETER_FOR_CANAL_CONNECTION: "14",

    CREW_TYPE_PARAMETER_FOR_INFRASTRUCTURE_DESTRUCTION_APPLICATION: "15",


    PARAMETER_TYPE_ABSENTEEISM_STATUS: "378",

    REVENUE_ECONOMIC_CLASSIFICATION_STATUS_ACTIVE: "1",

    REVENUE_ECONOMIC_CLASSIFICATION_STATUS_PASSIVE: "0",

    REVENUE_ECONOMIC_CLASSIFICATION_STATUS_DELETED_BY_USER: "2",

    FINANCING_ECONOMIC_CLASSIFICATION_STATUS_ACTIVE: "1",

    FINANCING_ECONOMIC_CLASSIFICATION_STATUS_PASSIVE: "0",

    FINANCING_ECONOMIC_CLASSIFICATION_STATUS_DELETED_BY_USER: "2",

    APPLICATION_TYPE_CANAL_CONNECTION_APPLICATION: "45",

    PARAMETER_TYPE_AMORTIZATION_PERIOD_TYPES: "382",
    AMORTIZATION_PERIOD_TYPE_YEARLY: "1",
    AMORTIZATION_PERIOD_TYPE_MONTHLY: "2",

    PARAMETER_TYPE_SUBSCRIPTION_STATUS_FOR_REPORT: "385",
    SUBSCRIPTION_STATUS_FOR_REPORT_ALL: "0",
    SUBSCRIPTION_STATUS_FOR_REPORT_NEW_SUBSCRIPTION: "1",
    SUBSCRIPTION_STATUS_FOR_REPORT_CANCELLED_SUBSCRIPTION: "2",
    SUBSCRIPTION_STATUS_FOR_REPORT_OVER_TAKEN_SUBSCRIPTION: "3",
    SUBSCRIPTION_STATUS_FOR_REPORT_ASSIGNED_SUBSCRIPTION: "4",
    SUBSCRIPTION_STATUS_FOR_REPORT_ACTIVE: "5",
    SUBSCRIPTION_STATUS_FOR_REPORT_PASSIVE: "6",

    PARAMETER_TYPE_SERVICE_APPLICATION_OPERATIONS: "386",

    ACCOUNTING_PAYMENT_TYPE_CHECK: "2",
    ACCOUNTING_PAYMENT_TYPE_PAYMENT_ORDER: "3",

    PARAMETER_TYPE_COLLECTION_UNBLOCKING: "392",
    PARAMETER_CODE_COLLECTION_UNBLOCKING_RATIO: "1",

    ELECTION_PARAMETER_TYPE: "282",
    PUBLIC_FACILITY_TYPE_PARAMETER_TYPE: "279",

    MARRIAGE_KIND_PARAMETER_TYPE: "067",

    MARRIAGE_PLACE_PARAMETER_TYPE: "068",

    PROPERTY_REGIME_TYPE_PARAMETER_TYPE: "069",

    RELIGION_TYPE_PARAMETER_TYPE: "070",

    MARITALSTATUS_TYPE_PARAMETER_TYPE: "071",

    BLOODGROUP_TYPE_PARAMETER_TYPE: "072",

    REASONOFISSUE_TYPE_PARAMETER_TYPE: "073",

    GENDER_TYPE_PARAMETER_TYPE: "074",

    FATHERDEATH_TYPE_PARAMETER_TYPE: "075",

    MOTHERDEATH_TYPE_PARAMETER_TYPE: "076",

    ISTHEREANOTHERCITIZENSHIP_PARAMETER_TYPE: "078",

    HASRELATIONSHIPWHOMARRIEDWITH_PARAMETER_TYPE: "079",

    ISMARRIEDBEFORE_PARAMETER_TYPE: "080",

    WILLBETURKISHCITIZENSHIPAFTERMARRIAGE_PARAMETER_TYPE: "081",

    ISPERMISSIONREQUIREDTOMARRIAGE_PARAMETER_TYPE: "082",

    ISSURNAMEWILLUSEDAFTERMARRIAGE_PARAMETER_TYPE: "083",

    MUKTHAR_TERM_PARAMETER_TYPE: "277",

    PRINTER_TYPE_LASER: "1",

    PRINTER_TYPE_DOT_MATRIX: "2",

    PARAMETER_TYPE_RESTRUCTURING_PRICE_INDEX: "398",

    PARAMETER_TYPE_EXPENSE_ECONOMIC_CLASSIFICATION_TYPE: "397",

    PARAMETER_TYPE_ACCOUNTING_FIRM_REPORT_TYPES: "399",

    PARAMETER_TYPE_ACCOUNTING_HELPER_REPORT_TYPES: "400",

    PARAMETER_TYPE_ACCOUNTING_FINANCIAL_BOOK_REPORT_TYPES: "401",

    PARAMETER_TYPE_ACCOUNTING_STRATEGIC_PLAN_REPORT_TYPES: "402",

    PARAMETER_TYPE_ACCOUNTING_PERSONNEL_TURNOVER_REPORT_TYPES: "403",

    PARAMETER_TYPE_ACCOUNTING_FINANCIAL_TABLE_REPORT_TYPES: "404",

    PARAMETER_TYPE_ACCOUNTING_ACCOUNT_PLAN_LEVELS: "407",

    PARAMETER_TYPE_FINAL_ACCOUNT_AND_FINANCIAL_STATEMENT_ACCOUNTING_ACCOUNT_PLAN_LEVELS: "408",

    PARAMETER_TYPE_ACCOUNTING_OFFICIAL_REPORT_TYPES: "409",

    PARAMETER_TYPE_LATE_DEBT_NOTICE_LAW_TYPE: "410",

    PARAMETER_TYPE_BLOCKAGE_TYPE: "412",

    PARAMETER_TYPE_SHORT_MESSAGE_CONTENT_PARAMETERS: "417",
    PARAMETER_TYPE_CODE_MOVEABLE_PROPERTY_PROCESS_RECEIPT_DELIVER_STATUS: "418",
    PARAMETER_TYPE_SMS_ADDRESS_TYPE_PARAMETERS: "420",
    PARAMETER_TYPE_REQUEST_TYPES: "415",

    PARAMETER_TYPE_REQUEST_STATUS: "416",

    PARAMETER_TYPE_CODE_MOVEABLE_PROPERTY_PROCESS_RECEIPT_STORAGEHOUSE_TRANSFER_STATUS: "419",

    PARAMETER_TYPE_REVENUE_MODULE: "274",

    PARAMETER_TYPE_CODE_MOVEABLE_DEREGISTRATION_STATUS: "422",

    PARAMETER_TYPE_SMS_GROUPS: "425",

    PARAMETER_TYPE_SYNDICATE_CALCULATION_TYPES: "434",


    //React için yazılan sabitler
    TURKISH_CULTURE: "TR",
    PARAMETER_TYPE_PROMISE_OTHER_PROCESS_TYPE: "441",

    PARAMETER_TYPE_WITHHOLDING_RATE: "430",

}

export default ParameterConstants;